// farm-booking/frontend/src/pages/AdminSite.jsx
// Admin Hero - Gestion settings site (headline, média, carte OSM)
// 73+ Papy

import { useState, useEffect } from 'react'
import './AdminSite.css'

function AdminSite() {
  const [settings, setSettings] = useState(null)
  const [loading, setLoading] = useState(true)
  const [saving, setSaving] = useState(false)
  const [message, setMessage] = useState(null)

  // Chargement des settings
  useEffect(() => {
    const token = localStorage.getItem('admin_token')
    if (!token) {
      window.location.href = '/auth'
      return
    }

    fetch('/api/settings')
      .then(res => res.json())
      .then(data => {
        setSettings(data)
        setLoading(false)
      })
      .catch(err => {
        console.error('Erreur:', err)
        setLoading(false)
      })
  }, [])

  // Sauvegarde des settings
  const handleSave = async (e) => {
    e.preventDefault()
    setSaving(true)
    setMessage(null)

    const token = localStorage.getItem('admin_token')

    try {
      const res = await fetch('/api/admin/settings', {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(settings)
      })

      if (res.ok) {
        setMessage({ type: 'success', text: '✅ Paramètres sauvegardés !' })
      } else {
        setMessage({ type: 'error', text: '❌ Erreur sauvegarde' })
      }
    } catch (error) {
      setMessage({ type: 'error', text: '❌ Erreur serveur' })
    } finally {
      setSaving(false)
    }
  }

  // Mise à jour d'un champ
  const updateField = (field, value) => {
    setSettings({ ...settings, [field]: value })
  }

  // Déconnexion
  const handleLogout = () => {
    localStorage.removeItem('admin_token')
    window.location.href = '/'
  }

  if (loading) {
    return (
      <div className="admin-site-loading">
        <div className="spinner"></div>
        <p>Chargement...</p>
      </div>
    )
  }

  return (
    <div className="admin-site">
      <header className="admin-site-header">
        <div className="admin-site-header-content">
          <h1>🌱 Admin Site - La Ferme du Petit Essart</h1>
          <div className="admin-site-header-actions">
            <a href="/admin-farm" className="btn-secondary">
              🚜 Admin Réservations
            </a>
            <a href="/" className="btn-secondary">
              🏠 Voir le site
            </a>
            <button onClick={handleLogout} className="btn-logout">
              🚪 Déconnexion
            </button>
          </div>
        </div>
      </header>

      <main className="admin-site-main">
        <form onSubmit={handleSave} className="admin-site-form">
          
          {/* Message de feedback */}
          {message && (
            <div className={`admin-site-message ${message.type}`}>
              {message.text}
            </div>
          )}

          {/* Section Hero */}
          <section className="admin-site-section">
            <h2>📢 Bannière d'accueil</h2>
            
            <div className="form-group">
              <label>Texte de la bannière (headline)</label>
              <input
                type="text"
                value={settings?.hero_headline || ''}
                onChange={(e) => updateField('hero_headline', e.target.value)}
                placeholder="Bienvenue à La Ferme du Petit Essart"
              />
            </div>

            <div className="form-group">
              <label>Type de média</label>
              <select
                value={settings?.hero_type || 'image'}
                onChange={(e) => updateField('hero_type', e.target.value)}
              >
                <option value="image">Image</option>
                <option value="video">Vidéo</option>
              </select>
            </div>

            <div className="form-group">
              <label>URL du média (image ou vidéo)</label>
              <input
                type="text"
                value={settings?.hero_media_url || ''}
                onChange={(e) => updateField('hero_media_url', e.target.value)}
                placeholder="/uploads/images/hero.webp"
              />
              <small>📁 Uploader le fichier dans /opt/farm-booking/frontend/public/uploads/images/</small>
            </div>
          </section>

          {/* Section Coordonnées */}
          <section className="admin-site-section">
            <h2>📍 Coordonnées</h2>

            <div className="form-group">
              <label>Adresse</label>
              <input
                type="text"
                value={settings?.adresse || ''}
                onChange={(e) => updateField('adresse', e.target.value)}
                placeholder="Rue Champ du Bois, 76530 Grand-Couronne"
              />
            </div>

            <div className="form-group">
              <label>Email de contact</label>
              <input
                type="email"
                value={settings?.contact_email || settings?.email_contact || ''}
                onChange={(e) => updateField('contact_email', e.target.value)}
                placeholder="contact@lafermedupetitessart.fr"
              />
            </div>

            <div className="form-group">
              <label>Téléphone</label>
              <input
                type="tel"
                value={settings?.contact_phone || settings?.telephone || ''}
                onChange={(e) => updateField('contact_phone', e.target.value)}
                placeholder="06 12 34 56 78"
              />
            </div>

            <div className="form-group">
              <label>Horaires d'ouverture</label>
              <input
                type="text"
                value={settings?.opening_hours || settings?.horaires_distribution || ''}
                onChange={(e) => updateField('opening_hours', e.target.value)}
                placeholder="Jeudi 17h30-19h30"
              />
            </div>
          </section>

          {/* Section Carte OSM */}
          <section className="admin-site-section">
            <h2>🗺️ Carte OpenStreetMap</h2>

            <div className="form-row">
              <div className="form-group">
                <label>Latitude GPS</label>
                <input
                  type="text"
                  value={settings?.gps_latitude || ''}
                  onChange={(e) => updateField('gps_latitude', e.target.value)}
                  placeholder="49.33611443214846"
                />
              </div>

              <div className="form-group">
                <label>Longitude GPS</label>
                <input
                  type="text"
                  value={settings?.gps_longitude || ''}
                  onChange={(e) => updateField('gps_longitude', e.target.value)}
                  placeholder="1.0261647022935751"
                />
              </div>

              <div className="form-group">
                <label>Zoom</label>
                <input
                  type="number"
                  value={settings?.gps_zoom || '17'}
                  onChange={(e) => updateField('gps_zoom', e.target.value)}
                  min="1"
                  max="20"
                />
              </div>
            </div>

            <small>
              💡 Trouver vos coordonnées GPS : 
              <a href="https://www.openstreetmap.org/" target="_blank" rel="noopener noreferrer">
                OpenStreetMap.org
              </a>
            </small>
          </section>

          {/* Section Mode maintenance */}
          <section className="admin-site-section">
            <h2>🔧 Mode maintenance</h2>

            <div className="form-group">
              <label>État du site</label>
              <select
                value={settings?.etat_site || 'ouvert'}
                onChange={(e) => updateField('etat_site', e.target.value)}
              >
                <option value="ouvert">✅ Ouvert (mode normal)</option>
                <option value="maintenance">🔧 Maintenance (site fermé)</option>
              </select>
              <small>
                ⚠️ En mode maintenance, seules les pages admin restent accessibles
              </small>
            </div>
          </section>

          {/* Bouton de sauvegarde */}
          <div className="admin-site-actions">
            <button type="submit" className="btn-save" disabled={saving}>
              {saving ? '💾 Sauvegarde...' : '💾 Sauvegarder'}
            </button>
          </div>

        </form>
      </main>

      <footer className="admin-site-footer">
        © 2025 La Ferme du Petit Essart – Admin Site
      </footer>
    </div>
  )
}

export default AdminSite
